const FLAG_GETTING_STARTED = 'getting_started';
export const getShowGettingStorage = (): boolean =>
  Boolean(localStorage.getItem(FLAG_GETTING_STARTED));

export const setShowGettingStorage = (): boolean =>
  Boolean(localStorage.setItem(FLAG_GETTING_STARTED, 'yes'));
